import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FetcherWithComponents } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { HomeAction } from 'views/home/Home';
import { useSnackbar } from "notistack";
import { ToastContainer } from 'react-toastify';

interface DeleteCampaingDialogProps {
    open: boolean;
    handleClose: () => void;
    fetcher: FetcherWithComponents<any>;
    handleOpen: () => void;
    campaignId: number,
    campaignCmId: string
}

const CampaignDeleteDialog = ({
    open,
    handleClose,
    fetcher,
    handleOpen,
    campaignId,
    campaignCmId,
}: DeleteCampaingDialogProps) => {
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <ToastContainer />
                <DialogTitle id="alert-dialog-title">
                    {"Confirmation de suppression"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Voulez-vous vraiment supprimer cette campagne ?
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <fetcher.Form
                        method="post"
                        id="deleteCampaing"
                    >
                        <input type="text" name="campaignId" value={campaignId} hidden readOnly />
                        <input type="text" name="campaignCmId" value={campaignCmId} hidden readOnly />
                        <input type="hidden" name="action" value={HomeAction.DeleteCampaing} readOnly />

                        <Button onClick={handleClose} color="error">Non</Button>
                        <LoadingButton
                            type="submit"
                            form="deleteCampaing"
                            loading={fetcher.state === "submitting"}
                            color="info"
                        // onClick={scheduleCampaingAction}
                        >
                            Oui
                        </LoadingButton>
                    </fetcher.Form>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CampaignDeleteDialog;